import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { ChevronRight, Left } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { PageHeader } from '../../../components/PageHeader';
import { selectWorks } from '../../Api/selectors';
import { fetchVehicle } from '../actions';
import { REQUEST_VEHICLE } from '../constants';
import { selectVehicle } from '../selectors';
import { VehicleDetailsDocuments } from './detailsDocuments';
import { VehicleDetailsPrice } from './detailsPrice';
import { DetailsSupplier } from './detailsSupplier';
import { VehicleDetailsVars } from './detailsVars';
import { OptionsEditor } from './OptionsEditor';
import { VehicleInvoices } from './details/vehicleInvoices';
import { VehicleDetailsActions } from './detailsActions';
import { Modal } from '../../../components/Modal';
import { VehicleDetailsState } from './detailsState';
import { VehicleHexon } from './detailsHexon';
import { VehicleDetailsHistory } from './detailsHistory';
import { VehicleHemex } from './detailsHemex';
import { VehicleSilverdat } from './detailsSilverdat';
import { VehicleCarcollect } from './detailsCarCollect';
import { OrehVehicleExport } from './detailsOrehVehicleExport';
import { VehicleDetailsInvoices } from './detailsInvoces';
import { VehicleDetailsInspectionType2 } from './detailsInspectionType2';
import { VehicleDetailsColumns } from './detailsColumns';
import LoadingDetailsPage from '../../../containers/App/Components/LoadingDetailsPage/LoadingDetailsPage';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
const Container = styled.div`
  color: #6e6e6e;
  font-weight: 400;

  .content {
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    this.props.fetch(this.props.vehicle_id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle_id !== this.props.vehicle_id) {
      this.props.fetch(this.props.vehicle_id);
    }
  }

  goBack(event) {
    window.history.go(-1);
  }

  get vehicle() {
    return this.props.vehicle;
  }

  render() {
    //don't render loader, that would reset the pages below

    if (!this.vehicle)
      return (
        <>
          <PageHeader
            title={
              <div
                className="pointer"
                onClick={() => {
                  this.props.history.push(back_url, { state: { fromVehicleDetails: true } });
                }}
              >
                <Left />
                {this.lbl('vehicle.overview.title')}
              </div>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('vehicle.overview.title')}
                <ChevronRight />
                {this.vehicle?.brand_name}&nbsp;{this.vehicle?.model_name}&nbsp;{this.vehicle?.type}
              </>
            }
          />
          <LoadingDetailsPage version="versionVehicle" />
        </>
      );

    const back_url = this.props.history.location.pathname.slice(0, this.props.history.location.pathname.lastIndexOf('/'));

    return (
      <div className="container-fluid p-0">
        <PageHeader
          title={
            <div className="pointer" onClick={this.tofn(back_url)}>
              <Left />
              {this.lbl('vehicle.overview.title')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('vehicle.overview.title')}
              <ChevronRight />
              {this.vehicle?.brand_name}&nbsp;{this.vehicle?.model_name}&nbsp;{this.vehicle?.type}
            </>
          }
        />

        <>
          <Switch>
            <Route
              path="(.*)/legacy"
              render={component => <VehicleDetailsVars key={this.props.vehicle_id} vehicle={this.props.vehicle} />}
            />
            <Route
              path="(.*)/inspection2"
              render={component => (
                <VehicleDetailsInspectionType2 key={this.props.vehicle_id} vehicle={this.props.vehicle} />
              )}
            />
            <Route path="(.*)/documents" render={component => <VehicleDetailsDocuments vehicle={this.props.vehicle} />} />
            <Route path="(.*)/options" render={component => <OptionsEditor vehicle={this.props.vehicle} />} />
            <Route path="(.*)/price" render={component => <VehicleDetailsPrice vehicle={this.props.vehicle} />} />
            <Route path="(.*)/supplier" render={component => <DetailsSupplier vehicle={this.props.vehicle} />} />
            <Route path="(.*)/invoices" render={component => <VehicleInvoices vehicle={this.props.vehicle} />} />
            <Route path="(.*)/state" render={component => <VehicleDetailsState vehicle={this.props.vehicle} />} />
            <Route path="(.*)/hexon" render={component => <VehicleHexon vehicle={this.props.vehicle} />} />
            <Route path="(.*)/history" render={component => <VehicleDetailsHistory vehicle={this.props.vehicle} />} />
            <Route path="(.*)/hemex" render={component => <VehicleHemex vehicle={this.props.vehicle} />} />
            <Route path="(.*)/silverdat" render={component => <VehicleSilverdat vehicle={this.props.vehicle} />} />
            <Route path="(.*)/carcollect" render={component => <VehicleCarcollect vehicle={this.props.vehicle} />} />
            {env.clientId === AppClientId.AUTOWIENTJES && (
              <Route path="(.*)/oreh" render={component => <OrehVehicleExport vehicle={this.props.vehicle} />} />
            )}

            <Route
              path="(.*)/actions"
              render={component => <VehicleDetailsActions key={this.props.vehicle.id} vehicle={this.props.vehicle} />}
            />
            <VehicleDetailsColumns
              key={this.props.vehicle_id}
              vehicle_id={this.props.vehicle_id}
              vehicle={this.props.vehicle}
            />
            <Route
              render={component => (
                <VehicleDetailsColumns
                  key={this.props.vehicle_id}
                  vehicle_id={this.props.vehicle_id}
                  vehicle={this.props.vehicle}
                />
              )}
            />
          </Switch>
        </>
      </div>
    );
  }
}

VehicleDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicle_id),
    work: selectWorks([REQUEST_VEHICLE]),
  })(state, ownProps);

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id) {
      dispatch(fetchVehicle(id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetails = compose(withConnect, withRouter)(VehicleDetailsComp);
